<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar class="add-new-data-sidebar items-no-padding" click-not-close color="primary" default-index="1" parent="body" position-right spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? 'ADD NEW' : 'UPDATE' }} ITEM</h4>
      <feather-icon @click.stop="isSidebarActiveLocal = false" class="cursor-pointer" icon="XIcon"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" :key="$vs.rtl" :settings="settings" class="scroll-area--data-list-add-new">

      <div class="p-6">

        <!-- Product Image -->
        <template v-if="dataImg">

          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataImg" alt="img" class="responsive">
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input @change="updateCurrImg" accept="image/*" class="hidden" ref="updateImgInput" type="file">
            <vs-button @click="$refs.updateImgInput.click()" class="mr-4" type="flat">Update Image</vs-button>
            <vs-button @click="dataImg = null" color="#999" type="flat">Remove Image</vs-button>
          </div>
        </template>

        <!-- NAME -->
        <vs-input class="mt-5 w-full" label="Name" name="item-name" v-model="dataName" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>

        <!-- CATEGORY -->
        <vs-select class="mt-5 w-full" label="Category" name="item-category" v-model="dataCategory" v-validate="'required'">
          <vs-select-item :key="item.value" :text="item.text" :value="item.value" v-for="item in category_choices"/>
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-category')">{{ errors.first('item-category') }}</span>

        <!-- ORDER STATUS -->
        <vs-select class="mt-5 w-full" label="Order Status" v-model="dataOrder_status">
          <vs-select-item :key="item.value" :text="item.text" :value="item.value" v-for="item in order_status_choices"/>
        </vs-select>

        <!-- PRICE -->
        <vs-input
          class="mt-5 w-full"
          icon="icon-dollar-sign"
          icon-pack="feather"
          label="Price"
          name="item-price"
          v-model="dataPrice"
          v-validate="{ required: true, regex: /\d+(\.\d+)?$/ }"/>
        <span class="text-danger text-sm" v-show="errors.has('item-price')">{{ errors.first('item-price') }}</span>

        <!-- Upload -->
        <!-- <vs-upload text="Upload Image" class="img-upload" ref="fileUpload" /> -->

        <div class="upload-img mt-5" v-if="!dataImg">
          <input @change="updateCurrImg" accept="image/*" class="hidden" ref="uploadImgInput" type="file">
          <vs-button @click="$refs.uploadImgInput.click()">Upload Image</vs-button>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button :disabled="!isFormValid" @click="submitData" class="mr-6">Submit</vs-button>
      <vs-button @click="isSidebarActiveLocal = false" color="danger" type="border">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  export default {
    props:      {
      isSidebarActive: {
        type:     Boolean,
        required: true
      },
      data:            {
        type:    Object,
        default: () => {}
      }
    },
    components: {
      VuePerfectScrollbar
    },
    data ()
    {
      return {

        dataId:           null,
        dataName:         '',
        dataCategory:     null,
        dataImg:          null,
        dataOrder_status: 'pending',
        dataPrice:        0,

        category_choices: [
          {text: 'Audio', value: 'audio'},
          {text: 'Computers', value: 'computers'},
          {text: 'Fitness', value: 'fitness'},
          {text: 'Appliance', value: 'appliance'}
        ],

        order_status_choices: [
          {text: 'Pending', value: 'pending'},
          {text: 'Canceled', value: 'canceled'},
          {text: 'Delivered', value: 'delivered'},
          {text: 'On Hold', value: 'on_hold'}
        ],
        settings:             { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed:         .60
        }
      }
    },
    watch:      {
      isSidebarActive (val)
      {
        if (!val) return
        if (Object.entries(this.data).length === 0)
        {
          this.initValues()
          this.$validator.reset()
        } else
        {
          const {category, id, img, name, order_status, price} = JSON.parse(JSON.stringify(this.data))
          this.dataId                                          = id
          this.dataCategory                                    = category
          this.dataImg                                         = img
          this.dataName                                        = name
          this.dataOrder_status                                = order_status
          this.dataPrice                                       = price
          this.initValues()
        }
        // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
      }
    },
    computed:   {
      isSidebarActiveLocal: {
        get ()
        {
          return this.isSidebarActive
        },
        set (val)
        {
          if (!val)
          {
            this.$emit('closeSidebar')
            // this.$validator.reset()
            // this.initValues()
          }
        }
      },
      isFormValid ()
      {
        return !this.errors.any() && this.dataName && this.dataCategory && this.dataPrice > 0
      },
      scrollbarTag () { return this.$store.getters.scrollbarTag }
    },
    methods:    {
      initValues ()
      {
        if (this.data.id) return
        this.dataId           = null
        this.dataName         = ''
        this.dataCategory     = null
        this.dataOrder_status = 'pending'
        this.dataPrice        = 0
        this.dataImg          = null
      },
      submitData ()
      {
        this.$validator.validateAll().then(result => {
          if (result)
          {
            const obj = {
              id:           this.dataId,
              name:         this.dataName,
              img:          this.dataImg,
              category:     this.dataCategory,
              order_status: this.dataOrder_status,
              price:        this.dataPrice
            }

            if (this.dataId !== null && this.dataId >= 0)
            {
              this.$store.dispatch('dataList/updateItem', obj).catch(err => { console.error(err) })
            } else
            {
              delete obj.id
              obj.popularity = 0
              this.$store.dispatch('dataList/addItem', obj).catch(err => { console.error(err) })
            }

            this.$emit('closeSidebar')
            this.initValues()
          }
        })
      },
      updateCurrImg (input)
      {
        if (input.target.files && input.target.files[0])
        {
          const reader  = new FileReader()
          reader.onload = e => {
            this.dataImg = e.target.result
          }
          reader.readAsDataURL(input.target.files[0])
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
</style>
